module.exports={"Star Rating":"Bewertungssterne","# star(s)":"{currentRating, plural, =1{# Stern} other{# Sterne}}"};